// src/components/Layout.jsx
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Layout({ children }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => { logout(); navigate('/'); };

  const links = [
    { path: '/dashboard', label: '📊 Dashboard' },
    { path: '/ordenes', label: '📋 Órdenes' },
    { path: '/consulta', label: '🔍 Consulta' },
    { path: '/productos', label: '📦 Productos' },
    { path: '/inventario', label: '🏭 Inventario' },
  ];

  return (
    <div style={s.container}>
      <aside style={s.sidebar}>
        <div style={s.logo}>🔧 Zoler</div>
        <nav style={s.nav}>
          {links.map(l => (
            <Link
              key={l.path}
              to={l.path}
              style={{...s.navLink, ...(location.pathname === l.path ? s.navLinkActivo : {})}}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div style={s.footer}>
          <p style={s.usuario}>👤 {usuario?.nombre}</p>
          <button style={s.botonSalir} onClick={handleLogout}>Cerrar sesión</button>
        </div>
      </aside>
      <main style={s.main}>{children}</main>
    </div>
  );
}

const s = {
  container: { display: 'flex', minHeight: '100vh', background: '#0f0f1a' },
  sidebar: { width: 220, background: '#1e1e2e', display: 'flex', flexDirection: 'column', padding: '24px 16px' },
  logo: { color: '#fff', fontSize: 22, fontWeight: 'bold', marginBottom: 40 },
  nav: { display: 'flex', flexDirection: 'column', gap: 8, flex: 1 },
  navLink: { color: '#aaa', textDecoration: 'none', padding: '10px 16px', borderRadius: 8, fontSize: 14 },
  navLinkActivo: { background: '#2d2d44', color: '#fff' },
  footer: { borderTop: '1px solid #2d2d44', paddingTop: 16 },
  usuario: { color: '#aaa', fontSize: 13, marginBottom: 8 },
  botonSalir: { background: 'none', border: '1px solid #e63946', borderRadius: 8, color: '#e63946', padding: '8px 12px', cursor: 'pointer', width: '100%', fontSize: 13 },
  main: { flex: 1, padding: 32, overflowY: 'auto' },
};